
import TXT_Panera_01 from "./TXT_Panera_01.png";
import TXT_Panera_02 from "./TXT_Panera_02.png";
import TXT_Panera_03 from "./TXT_Panera_03.png";
import TXT_Panera_04 from "./TXT_Panera_04.png";
import TXT_Panera_05 from "./TXT_Panera_05.png";

import TXT_Quesera_2018 from "./TXT_Quesera Bolsa_2018_AL.png";
import TXT_Quesera_2026 from "./TXT_Quesera Bolsa_2026_AL.png";

export const textureActivityTheme3 = {
	topic1: {
		act1: {
			paneara: {
				p1: TXT_Panera_01,
				p2: TXT_Panera_02,
				p3: TXT_Panera_03,
				p4: TXT_Panera_04,
				p5: TXT_Panera_05,
			}
		},
		act4: {
			quesera: {
				age2018: TXT_Quesera_2018,
				age20226: TXT_Quesera_2026
			}
		}
	}
}